var _rect, _path, _circle, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 58.5102,
    rx: 8,
    fill: "#FFEECC",
    fillOpacity: 0.958352
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.357 12.449H16.028C14.4184 12.449 12.8748 12.9744 11.7366 13.9095C10.5985 14.8447 9.95911 16.1131 9.95911 17.4356V44.0312C9.95911 45.3537 10.5985 46.6221 11.7366 47.5573C12.8748 48.4925 14.4184 49.0179 16.028 49.0179H44.3494C45.959 49.0179 47.5026 48.4925 48.6408 47.5573C49.7789 46.6221 50.4183 45.3537 50.4183 44.0312V21.011C50.315 21.0142 50.2113 21.0158 50.1071 21.0158C48.7599 21.0158 47.4897 20.7453 46.3724 20.2668V44.0312C46.3724 44.472 46.1592 44.8948 45.7799 45.2066C45.4005 45.5183 44.8859 45.6934 44.3494 45.6934H16.028C15.4915 45.6934 14.9769 45.5183 14.5975 45.2066C14.2182 44.8948 14.005 44.472 14.005 44.0312V17.4356C14.005 16.9948 14.2182 16.572 14.5975 16.2603C14.9769 15.9485 15.4915 15.7734 16.028 15.7734H42.1966C42.0778 15.32 42.0152 14.8495 42.0152 14.3669C42.0152 13.7001 42.1347 13.0563 42.357 12.449Z",
    fill: "#A77C27"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 14.5,
    r: 4.5,
    stroke: "#A77C27",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#A77C27"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#A77C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.cbcb389b0115b15bed3f9e353089a1ac.svg";
export { ForwardRef as ReactComponent };